/**
 * Indigrey Drag Fix v1.0
 * Prevents accidental link/button clicks during Swiper drag gestures.
 * Also improves touch momentum and cursor feedback.
 */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 6; // px movement before we consider it a drag

  function initSwiperDragFix() {
    var swipers = document.querySelectorAll('.swiper');
    swipers.forEach(function (el) {
      var startX = 0;
      var startY = 0;
      var isDragging = false;

      el.addEventListener('mousedown', function (e) {
        startX = e.clientX;
        startY = e.clientY;
        isDragging = false;
      }, { passive: true });

      el.addEventListener('mousemove', function (e) {
        var dx = Math.abs(e.clientX - startX);
        var dy = Math.abs(e.clientY - startY);
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          isDragging = true;
          el.classList.add('is-dragging');
        }
      }, { passive: true });

      el.addEventListener('mouseup', function () {
        setTimeout(function () {
          isDragging = false;
          el.classList.remove('is-dragging');
        }, 50);
      }, { passive: true });

      // Click blocker
      el.addEventListener('click', function (e) {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
          isDragging = false;
          el.classList.remove('is-dragging');
        }
      }, true);

      // Touch support
      var touchStartX = 0;
      var touchStartY = 0;
      var isTouchDragging = false;

      el.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isTouchDragging = false;
        }
      }, { passive: true });

      el.addEventListener('touchmove', function (e) {
        if (e.touches.length === 1) {
          var dx = Math.abs(e.touches[0].clientX - touchStartX);
          var dy = Math.abs(e.touches[0].clientY - touchStartY);
          if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
            isTouchDragging = true;
          }
        }
      }, { passive: true });

      el.addEventListener('touchend', function () {
        if (isTouchDragging) {
          el.addEventListener('click', function blockClick(e) {
            e.preventDefault();
            e.stopPropagation();
            el.removeEventListener('click', blockClick, true);
          }, true);
        }
        isTouchDragging = false;
      }, { passive: true });
    });
  }

  // Run after DOM ready and after Swiper instances are likely initialised
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initSwiperDragFix, 300);
    });
  } else {
    setTimeout(initSwiperDragFix, 300);
  }

  // Re-run on dynamic section changes (Shopify theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initSwiperDragFix, 400);
  });

})();
